import ajax from './ajax';

export const requestTopHospitals = (dkw) =>
  ajax[0].get('getTopHospitals.do', { params: { dkw } });
export const requestReportTopHospitals = (dkw, da) =>
  ajax[0].get('getReport.do', { params: { dkw, da } });
export const requestNetwordData = (dkw, rule) =>
  ajax[0].get('getNetworkData.do', { params: { dkw, rule } });
export const requestNodeNeiboursData = (dkw) =>
  ajax[0].get('getNeighbours.do', { params: { dkw } });
export const requestDiseaseInfo = (dkw) =>
  ajax[0].get('viewDiseaseByDkw.do', { params: { dkw } });
export const requestAutocompleteDkws = (dkw) =>
  ajax[0].get('getAutoCompleteDkws.do', { params: { dkw } });
export const requestNearbyPhysicians = (priSpec, zipcode, radius) =>
  ajax[0].get('physiciansNearby.do', { params: { priSpec, zipcode, radius } });
export const requestMatchedDkws = (dkws) =>
  ajax[0].get('getMatchedDkwsForGPT.do', { params: { dkws } });

export const geoCodingAddress = (query) =>
  ajax[2].get('forward', { params: { query }, headers: { 'Authorization': 'prj_test_sk_75ff082a4e532f6535e59799512859c722c2739f' } });


export const createRunningDetails = (runningDetails) =>
  ajax[1].post('/running/detail', runningDetails);
export const getRunnerInfo = (runnerId) => ajax[1].get('/runner/' + runnerId);
export const getTotalRunningData = () => ajax[1].get('/running/detail/all');



// WEBPACK FOOTER //
// ./src/api/index.js